import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=9b0cf0ac&scoped=true"
import script from "./Changelog.ts?vue&type=script&lang=ts&external"
export * from "./Changelog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0cf0ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0cf0ac')) {
      api.createRecord('9b0cf0ac', component.options)
    } else {
      api.reload('9b0cf0ac', component.options)
    }
    module.hot.accept("./Changelog.vue?vue&type=template&id=9b0cf0ac&scoped=true", function () {
      api.rerender('9b0cf0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Versioning/pages/Changelog/Changelog.vue"
export default component.exports